import { listenForChildRequests } from './consentChildListener';
import { initGtag } from './gtag';

initGtag(import.meta.env.VITE_GTAG_ID);
listenForChildRequests(() => window.__racemapUserConsent ?? null);
